import { HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from '../../../core/services/auth-service';
import { inject } from '@angular/core';
import { environment } from '../../../core/Environment/environment';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  let token = authService.retrieve('token');
  const urlTree = router.parseUrl(router.url);
  const userRole = urlTree.root.children['primary']?.segments[0]?.path;

  let baseUrl = userRole == 'admin' ? environment.dashboard_url : environment.merchant_url;
  let modifiedReq = req;

  modifiedReq = req.clone({
    url: `${baseUrl}${req.url}`,
  });

  if (token) {
    modifiedReq = modifiedReq.clone({
      headers: modifiedReq.headers.set('Authorization', `Bearer ${token}`),
    });
  }

  return next(modifiedReq).pipe(
    catchError((error) => {
      if (error.status === 401) {
        authService.logOut();
      }
      return throwError(() => error);
    })
  );
};
